import {BrowserModule} from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpXsrfTokenExtractor, provideHttpClient, withInterceptorsFromDi, withXsrfConfiguration } from '@angular/common/http';
import {DoBootstrap, inject, NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {
  NgbDateAdapter, NgbDateNativeAdapter,NgbToastModule
} from '@ng-bootstrap/ng-bootstrap';

import {HttpRequestInterceptor} from './http.interceptor';
import {ThrottleClickDirective} from './directives/throttle-click.directive';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {AuthModule} from './auth/auth.module';

import {NavigationComponent} from './navigation/navigation.component';
import {SideNavComponent} from './navigation/side-nav/side-nav.component';
import {BeachesModule} from './beaches/beaches.module';
import {PreCERCLISService} from './services/pre-cerclis.service';
import {TierIIService} from './services/tierii.service';
import {FUDSService} from './services/fuds.service';
import {BrownfieldsService} from './services/brownfields.service';
import {PesticidesService} from './services/pesticides.service';
import {ERService} from './services/er.service';

import {environment} from '../environments/environment';

import {StandbyGeneratorsService} from './standby-generators/standby-generators.service';
import {CommonModule} from '@angular/common';
import { MergeModalComponent } from './modals/merge-modal/merge-modal.component';
import { MapToolComponent } from './map-tool/map-tool.component';
import {RoutingReviewComponent} from './routing-review/routing-review/routing-review.component';
import {ReviewService} from './routing-review/review.service';
import {SearchComponent} from '@shared/search/search.component';
import {EditorComponent} from '@tinymce/tinymce-angular';
import {ResultsListComponent} from '@shared/results-list/results-list.component';
import {ToastComponent} from '@shared/toast/toast.component';
import {ErrorHandlingService} from '@shared/services/error-handling.service';
import {ToastService} from '@shared/services/toast.service';
import {WetlandsService} from './services/wetlands.service';

@NgModule({ declarations: [
        AppComponent,
        ThrottleClickDirective,
        MergeModalComponent,
        MapToolComponent, // HelpComponent
    ],
    bootstrap: [AppComponent],
    exports: [
    ], imports: [CommonModule,
        AuthModule,
        NavigationComponent,
        AppRoutingModule,
        BrowserModule,
        BeachesModule,
        FormsModule,
        SideNavComponent,
        SearchComponent,
        NgbToastModule,
        EditorComponent,
        RoutingReviewComponent,
        ResultsListComponent,
        ToastComponent
  ], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpRequestInterceptor,
            multi: true
        },
        { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
        { provide: 'environment', useValue: environment },
        BrownfieldsService,
        ERService,
        FUDSService,
        PesticidesService,
        PreCERCLISService,
        TierIIService,
        StandbyGeneratorsService,
        ReviewService,
        ErrorHandlingService,
        ToastService,
        provideHttpClient(withInterceptorsFromDi(), withXsrfConfiguration({ cookieName: 'csrftoken', headerName: 'X-CSRFToken' })),
        WetlandsService
    ] })
export class AppModule {}

